import * as body from './body';
export function isImplementation(node) {
    return body.getBody(node) !== undefined;
}
export function isOverload(node) {
    return !isImplementation(node);
}

//# sourceMappingURL=overload.js.map
